import React from 'react'
import styled, { css } from 'styled-components'

const width = '14'
const height = '23'
const viewBox = '0 0 14 23'

const getDimensions = () => ({
  height,
  width
})

const getDimensionsCss = () => css`
  width: ${width}px;
  height: ${height}px;
`

const Image = styled.svg`
  ${({ noStyles }) => (!noStyles ? getDimensionsCss() : null)}
`

const defaultProps = {
  children: [
    <path
      key="key-0"
      d="M3.83274 22.5C3.73628 22.5 3.64325 22.464 3.57234 22.3941C3.57227 22.3941 3.57221 22.394 3.57214 22.394L0.605684 19.4621L0.60567 19.4621C0.465895 19.324 0.466027 19.1027 0.605579 18.9648L0.605684 18.9647L7.72132 11.9321C7.72173 11.9317 7.72215 11.9313 7.72256 11.9309C7.96478 11.6925 7.9619 11.3051 7.72303 11.0691L0.605216 4.03493C0.605175 4.03489 0.605135 4.03485 0.605094 4.03481C0.465367 3.8965 0.465404 3.67499 0.605407 3.5367L0.605463 3.53664L3.57212 0.605431L3.57246 0.605097C3.71323 0.465733 3.94847 0.463945 4.09301 0.605877C4.0931 0.605967 4.09319 0.606056 4.09328 0.606146L11.6131 8.03815C11.6131 8.03816 11.6131 8.03816 11.6131 8.03817C13.5482 9.95089 13.5482 13.0494 11.6131 14.9621C11.6131 14.9621 11.6131 14.9621 11.6131 14.9621L4.0927 22.3941C4.02184 22.4641 3.92864 22.5 3.83274 22.5Z"
      fill="white"
      stroke="#0CBE7A"
    />
  ],
  viewBox
}

const IconChevron = Object.assign(Image, {
  getDimensions,
  getDimensionsCss,
  defaultProps,
  displayName: 'IconChevron'
})

export default IconChevron
